export const LOADING_STATE = {
    BEFORE: 0,
    DURING: 1,
    AFTER: 2,
};

export default {
    loading: 0,
    locationsLoading: LOADING_STATE.BEFORE,
    locations: [],
};
